module.exports = __webpack_public_path__ + "static/img/titlelog.9bd4fd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/titlelog.png
// module id = IiMg
// module chunks = 44